export default __webpack_public_path__ + "static/media/Collateral.49238e40.png";